
(function($) {

    'use strict';

    function validateLeadName(myForm) {

        var fname = $('#name', myForm).val();
        var lname = fname.split(' ');
        var errormsg = '';

        if (fname.indexOf(' ') > -1) {

            if (fname.length < 3 || lname[1].length < 3) {

                errormsg = 'Please Enter Your First and Last Name';
                $('.invalid-name small').text(errormsg);
                return false;

            } else {

                $('.invalid-name small').empty();
                return true;

            }

        } else {

            errormsg = 'Please Enter Your First and Last Name';
            $('.invalid-name small').text(errormsg);
            return false;

        }

    }

    function validateLeadEmail(myForm) {

        var $email = $('#email_address', myForm).val();
        var emailReg = /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,6})+$/;

        if (!emailReg.test($email)) {

            var errormsg = 'Please enter a valid email address.';
            $('.invalid-email small').text(errormsg);
            return false;

        } else {

            $('.invalid-email small').empty();
            return true;

        }

    }

    function onSubmit(token) { /* eslint-disable-line no-unused-vars */

        var $leadForm = $('#contact-form');

        var name = validateLeadName($leadForm),
            email = validateLeadEmail($leadForm);

        if (name !== false && email !== false) {

            $leadForm.find('#token').val(token);

            $.post(window.ajaxurl, $leadForm.serialize(), function(result) {

                if(result.success) {

                    $leadForm.fadeOut();

                    $('.form-contact').append($('<div class="success-message">Thanks for contacting us! We will get in touch with you shortly.</div>').fadeIn());

                }

            }, 'json');

        }
    }

    window.onSubmit = onSubmit;

})(jQuery);
